import { Link } from 'react-router-dom';

const Component = ({ plan }) => {
  const source = String(
    plan?.sourceCurrency || plan?.source || 'usdt'
  ).toLowerCase();
  const target = String(
    plan?.targetCurrency || plan?.target || 'usdt'
  ).toLowerCase();
  const title = plan?.title || 'BTC Accumulator (Structured Product)';
  const subtitle = plan?.subtitle || '';

  return (
    <div className="nk-ivp-card card card-bordered card-full">
      <div className="card-inner-group">
        <div className="card-inner">
          <div className="nk-ivp-title card-title">
            <h6 className="data">{title}</h6>
            <h1 className="icon-stack">
              {plan?.type === 'eth' ? (
                <em className="bg-eth-dim icon ni ni-sign-eth-alt"></em>
              ) : (
                <em className="bg-btc-dim icon ni ni-sign-btc-alt"></em>
              )}
            </h1>
            <br />
            <span className="data">Structured Product</span>
            <br />
            <span className="data">
              <i>{subtitle}</i>
            </span>
          </div>
          <div className="nk-ivp-action">
            <Link
              className="btn btn-primary"
              to={`/portal/planebtcaccumulator/${source}/${target}`}
              state={{
                productTitle: title,
                productSubtitle: subtitle,
                productType: plan.type,
              }}
            >
              <span>Invest</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;
